import React from "react";
import * as S from "./FlorenzToogle.style";
import useRecordNavigation from "../../../hooks/useRecordNavigation";

function FlorenzToogle({ 
  tabs, 
  activeTab, 
  setActiveTab, 
  color,
  backgroundColor,
  borderRadius,
  sizeFont
}) {
  const { recordAction } = useRecordNavigation();

  const handleTabClick = (tab) => {
    setActiveTab(tab.id);
    if(tab.action) recordAction(tab.action);
  };

  return (
    <S.FlorenzToogle 
      color={color} 
      backgroundColor={backgroundColor} 
      borderRadius={borderRadius}
      sizeFont={sizeFont}
    >
      {tabs.map((tab) => (
        <div
          onClick={() => handleTabClick(tab)}
          className={activeTab === tab.id ? "tab active-tab" : "tab"}
          key={tab.id}
        >
          <div className="tab__text">
            {tab.name}
          </div>
        </div>
      ))}
    </S.FlorenzToogle>
  )
}

export default FlorenzToogle;